import { Link } from "react-router-dom";
import type { PitchAssignment } from "@wmf/shared/pitchPractice";
import { get } from "../api.js";
import { useAsync } from "../useAsync.js";

export function PitchPracticeLink({ studentId }: { studentId: string }) {
  const state = useAsync(() => get<{ assignments: PitchAssignment[] }>(`/pitch-practice/family/${studentId}`), [studentId]);
  const live = Array.isArray(state.data?.assignments) ? state.data.assignments.filter(value => !value.archived) : [];
  if (!live.length) return null;
  return <section className="panel"><h2>Pitch practice</h2><p>{live.length} {live.length === 1 ? "scale or melodic pattern is" : "scales and melodic patterns are"} ready to practise.</p><Link to="/practice/pitch">Open assigned pitch exercises</Link></section>;
}
